import React, { useState } from "react";
import "./Navbar.css";
import Logo from "../../assets/png/logo.png";
import Identicon from "identicon.js";
import {
  BellFilled,
  CaretDownOutlined,
  InstagramFilled,
  MenuOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  TwitterOutlined,
  WalletOutlined,
  YoutubeFilled,
} from "@ant-design/icons";
import { Avatar, Button, Dropdown, Menu } from "antd";
import { Input } from "antd";
import { Link, useHistory } from "react-router-dom";
import SearchDrop from "../Search/SearchDrop";
import CreateDialogFun from "../../functions/CreateDialogFun";
import CreateDialog from "../CreateDialog/CreateDialog";
import ConnectDialog from "../ConnectDialog/ConnectDialog";
import ConnectDialogFun from "../../functions/ConnectDialogFun";
import NavDrawer from "./NavDrawer";
import NotificationDrop from "../Notification/NotificationDrop";
import MobileDrawerFun from "../../functions/MobileDrawerFun";
import SearchMobile from "../Search/SearchMobile";
import ProfileDrop from "../Profile/ProfileDrop";
import PinterestIcon from "@material-ui/icons/Pinterest";
import WalletDialog from "../Dialogs/WalletDialog";
import AutoPlayFun from "../../functions/AutoPlayFun";
import SocialDialog from "../ConnectDialog/SocialDialog";
import Web3 from "web3";
import WalletConnectProvider from '@walletconnect/web3-provider';
import Web3Modal from "web3modal";

const searchDrop = <SearchDrop />;
const searchMobile = (setVisibleSearch) => (
  <SearchMobile setVisibleSearch={setVisibleSearch} />
);
const notiMenu = <NotificationDrop />;

function openPageLink(url) {
  window.open(url);
}

const menu = (
  <Menu onClick={() => { }}>
    <Menu.Item key="1">
      <Link to="/token">SNFT Token</Link>
    </Menu.Item>
    <Menu.Item key="2">
      <Link to="/discussion">Discussion</Link>
    </Menu.Item>
    <Menu.Item key="3">
      <a target="__blank" href="https://www.snapshot.org">
        Voting
      </a>
    </Menu.Item>
    <Menu.Item key="4">
      <a target="__blank" href="https://www.nolt.io">
        Suggested feature
      </a>
    </Menu.Item>
    <Menu.Item key="5">
      <a target="__blank" href="https://www.substack.com">
        Subscribe
      </a>
    </Menu.Item>
    <div className="nav-community-menu-social">
      <TwitterOutlined
        onClick={() => openPageLink("https://twitter.com/NftSocial")}
      />
      <InstagramFilled
        onClick={() =>
          openPageLink("https://www.instagram.com/social.nft.marketplace/")
        }
      />
      <YoutubeFilled
        onClick={() =>
          openPageLink("https://www.pinterest.ca/SocialNFTmarketplace/_saved/")
        }
      />
      <PinterestIcon
        onClick={() =>
          openPageLink("https://www.pinterest.ca/SocialNFTmarketplace/_saved/")
        }
      />
    </div>
  </Menu>
);




const Navbar = () => {

  const history = useHistory();
  const [selected, setSelected] = useState(1);
  const [visibleSearch, setVisibleSearch] = useState(false);
  const [logged, setLogged] = useState(false);
  const [socialLogged, setSocialLogged] = useState(false);
  const [account, setAccount] = useState();
  const [balance, setBalance] = useState();


  const profileMenu = (toggleAutoplay, autoPlay) => (
    <ProfileDrop toggleAutoplay={toggleAutoplay} autoPlay={autoPlay} account={account} balance={balance} />
  );


  const selecteHeaderItem = (key) => {
    setSelected(key);
  };

  const goToHomePage = () => {
    selecteHeaderItem(1);
    history.push("/");
  };

  const { showCreateDialog, showDialog } = CreateDialogFun();
  const {
    dialogVisible,
    showConnectDialog,
    toggleWalletDialog,
    walletDialog,
    socialDialog,
    toggleSocialDialog,
  } = ConnectDialogFun();
  const { showDrawer, showMobileDrawer } = MobileDrawerFun();
  const { toggleAutoplay, autoPlay } = AutoPlayFun();

  // const goToDarkMode = () => {
  //   document.body.classList.toggle("dark-theme");
  // };

  const getAccountAndBalance = (account, balance) => {

    setAccount(account);
    setBalance(balance);

  }


  const connectToWalletFun = async () => {
    console.log("testing");
    debugger;
    // const providerOptions = {
    //   walletconnect: {
    //     package: WalletConnectProvider, // required
    //     options: {
    //       rpc: {
    //         NETWORKID: "https://data-seed-prebsc-1-s1.binance.org:8545"
    //       },
    //       network: "bsc"
    //     }
    //   }
    // };

    // const web3Modal = new Web3Modal({
    //   cacheProvider: true, // optional
    //   providerOptions
    // });

    // const providerOptions = {
    //   walletconnect: {
    //     package: WalletConnectProvider, // required
    //     options: {
    //       infuraId: '3372eec218054d8280084d9691432b04' // required
    //     }
    //   }
    // };

    //ROPSTON
    // const providerOptions = {
    //   walletconnect: {
    //     package: WalletConnectProvider, // required
    //     options: {
    //       infuraId: "3372eec218054d8280084d9691432b04" // required
    //     }
    //   }
    // };

    //BSC
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          rpc: {
            NETWORKID: "https://bsc-dataseed1.binance.org:443"
          },
          network: "bsc"
        }
      }
    };

    const web3Modal = new Web3Modal({
      // network: 'ropsten', // optional
      cacheProvider: true, // optional
      providerOptions
    });

    const provider = await web3Modal.connect();
    const web3js = new Web3(provider); // create web3 instance
    const accounts = await web3js.eth.getAccounts();
    console.log(`accounts ===> `, accounts)
    // accountStatusSource.next(accounts);
    const balance = await web3js.eth.getBalance(accounts[0]);
    // You can use balance here
    // this.totalEtheriumBalance = balance / 1e18;
    // await window.ethereum.enable();

    setLogged(true);
    getAccountAndBalance(accounts[0], balance / 1e18)

    console.log(`balance ====> `, balance);
    provider.on("accountsChanged", (accounts) => {
      console.log("accountsChanged ====> ", accounts);
    });

    // Subscribe to chainId change
    provider.on("chainChanged", (chainId) => {
      console.log("chainId ====> ", chainId);
    });

    // Subscribe to provider connection
    provider.on("connect", (info) => {
      console.log("info===", info);
    });

    // Subscribe to provider disconnection
    provider.on("disconnect", (error) => {
      console.log("disconnect===>", error);
    });

  }


  return (
    <div className="navbar">
      <div className="nav-context">
        <div className="nav-logo">
          <img onClick={goToHomePage} src={Logo} alt="learning logo" />
        </div>
        <div className="nav-items">
          <ul>
            <li onClick={() => selecteHeaderItem(1)}>
              <Link className={`${selected === 1 ? "active" : ""}`} to="/">
                Explore
              </Link>
            </li>
            <li onClick={() => selecteHeaderItem(2)}>
              <Link
                className={`${selected === 2 ? "active" : ""}`}
                to="/my-items"
              >
                My Socials
              </Link>
            </li>
            <li onClick={() => selecteHeaderItem(3)}>
              <Link
                className={`${selected === 3 ? "active" : ""}`}
                to="/following"
              >
                Following
              </Link>
            </li>
            <li onClick={() => selecteHeaderItem(4)}>
              <Link
                className={`${selected === 4 ? "active" : ""}`}
                to="/activity"
              >
                Activity
              </Link>
            </li>
            <li onClick={() => selecteHeaderItem(5)}>
              <Link
                className={`${selected === 5 ? "active" : ""}`}
                to="/how-it-work"
              >
                How It Work
              </Link>
            </li>
            <li>
              <Dropdown
                onClick={() => { }}
                overlay={menu}
                trigger={["click"]}
                placement="bottomCenter"
              >
                <div className="navbar-community">
                  <p>Community</p>
                  <CaretDownOutlined />
                </div>
              </Dropdown>
            </li>
          </ul>
        </div>
        <div className="nav-search">
          <Dropdown
            placement="bottomCenter"
            overlay={searchDrop}
            trigger={["click"]}
          >
            <Input
              placeholder="Search by collection, collectible or creator"
              allowClear
              suffix={<SearchOutlined style={{ color: "#595959" }} />}
            />
          </Dropdown>
        </div>
        <div className="nav-actions">
          <div className="tablet-search">
            <Dropdown
              placement="bottomCenter"
              overlay={searchMobile}
              trigger={["click"]}
            >
              <SearchOutlined />
            </Dropdown>
          </div>
          {!logged ? (
            <div className="nav-actions-container">
              <Button
                onClick={socialLogged ? showCreateDialog : toggleSocialDialog}
                icon={<PlusCircleOutlined />}
              >
                Create
              </Button>
              <Button onClick={() => { connectToWalletFun() }} icon={<WalletOutlined />}>
                Connect wallet
              </Button>
            </div>
          ) : (
            <div className="nav-actions-container">
              <Button onClick={showCreateDialog} icon={<PlusCircleOutlined />}>
                Create
              </Button>
              <div className="nav-bell-icon">
                <Dropdown
                  onClick={() => { }}
                  overlay={notiMenu}
                  trigger={["click"]}
                  placement="bottomLeft"
                >
                  <BellFilled
                    style={{ color: "#595959", fontSize: "1.2rem" }}
                  />
                </Dropdown>
              </div>
              <div className="navbar-account">
                <Dropdown
                  onClick={() => { }}
                  overlay={profileMenu(toggleAutoplay, autoPlay)}
                  trigger={["click"]}
                  placement="bottomLeft"
                >
                  <img
                    src={`data:image/png;base64,${new Identicon(
                      "asdhf9878fa8sdf78a7d4c2xewcwtr4r",
                      30
                    ).toString()}`}
                    alt="navbar account profile"
                  />
                </Dropdown>
              </div>
            </div>
          )}
        </div>
        <div className="mobile-drawer">
          <Dropdown
            placement="bottomCenter"
            overlay={searchMobile(setVisibleSearch)}
            trigger={["click"]}
            onVisibleChange={(e) => setVisibleSearch(e)}
            visible={visibleSearch}
          >
            <SearchOutlined />
          </Dropdown>
          <MenuOutlined onClick={showMobileDrawer} />
          {logged && (
            <Dropdown
              onClick={() => { }}
              overlay={notiMenu}
              trigger={["click"]}
              placement="bottomLeft"
            >
              <BellFilled style={{ color: "#595959", fontSize: "1.2rem" }} />
            </Dropdown>
          )}
          {logged && (
            <div className="navbar-account">
              <Dropdown
                onClick={() => { }}
                overlay={profileMenu}
                trigger={["click"]}
                placement="bottomLeft"
              >
                <img
                  src={`data:image/png;base64,${new Identicon(
                    "asdhf9878fa8sdf78a7d4c2xewcwtr4r",
                    30
                  ).toString()}`}
                  alt="navbar account profile"
                />
              </Dropdown>
            </div>
          )}
        </div>
      </div>
      <NavDrawer
        showConnectDialog={showConnectDialog}
        showCreateDialog={showCreateDialog}
        showDrawer={showDrawer}
        showMobileDrawer={showMobileDrawer}
        showSocialDialog={toggleSocialDialog}
      />
      <SocialDialog
        modalVisible={socialDialog}
        toggleDialog={toggleSocialDialog}
        setSocialLogged={setSocialLogged}
        toggleCreate={showCreateDialog}
      />
      <CreateDialog
        modalVisible={showDialog}
        showCreateDialog={showCreateDialog}
      />
      <ConnectDialog
        setLogged={setLogged}
        modalVisible={dialogVisible}
        showConnectDialog={showConnectDialog}
        toggleWalletDialog={toggleWalletDialog}
        getAccountAndBalance={getAccountAndBalance}
      />
      <WalletDialog
        modalVisible={walletDialog}
        toggleDialog={toggleWalletDialog}
      />
    </div>
  );
};

export default Navbar;
